<template>
  <div
    role="button"
    :tabindex="isDisabled ? -1 : 0"
    :class="[
      'flex cursor-pointer flex-col items-center justify-center border',
      compact ? 'w-[140px] rounded-sm p-2' : 'w-[180px] rounded-lg p-3',
      isSelected
        ? 'border-blue-500 bg-blue-50 hover:bg-blue-100'
        : 'border-gray-300 bg-white hover:bg-gray-50',
      isDisabled && 'cursor-not-allowed opacity-50'
    ]"
    :data-testid="`pin-clarify-preview-${optionLabel}`"
    @click="!isDisabled && emit('select')"
    @keydown.enter.space.prevent="!isDisabled && emit('select')"
  >
    <div
      :class="[
        'max-w-full truncate text-center font-bold',
        compact ? 'px-1 text-sm' : 'px-2 text-lg'
      ]"
      :style="{ fontFamily: `'${displayFont}', sans-serif`, color: displayColor }"
    >
      {{ textValue }}
    </div>
    <div
      :class="[
        'max-w-full truncate text-center text-gray-500',
        compact ? 'mt-0.5 px-1 text-[10px]' : 'mt-1 px-2 text-xs'
      ]"
    >
      {{ secondaryLabel }}
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useGoogleFont } from "./composables/useGoogleFont";

defineOptions({ name: "FontPreviewOption" });

const props = defineProps({
  textValue: { type: String, required: true },
  fontFamily: { type: String, required: true },
  color: { type: String, required: true },
  optionLabel: { type: String, required: true },
  optionValue: { type: String, required: true },
  isSelected: { type: Boolean, default: false },
  isDisabled: { type: Boolean, default: false },
  previewType: { type: String, required: true },
  compact: { type: Boolean, default: false }
});

const emit = defineEmits(["select"]);

const fontToLoad = computed(() =>
  props.previewType === "font" ? props.optionValue : props.fontFamily
);
useGoogleFont(fontToLoad);

const displayColor = computed(() =>
  props.previewType === "color" ? props.optionValue : props.color
);
const displayFont = computed(() =>
  props.previewType === "font" ? props.optionValue : props.fontFamily
);
const secondaryLabel = computed(() =>
  props.previewType === "color" ? `${props.optionLabel} (${props.optionValue})` : props.optionLabel
);
</script>
